const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const MonthlyInteresReportHeader = [
    { field: 'id', headerName: '#', width: 100, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    { field: 'muaji', headerName: 'Muaji', width: 392, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'trs', headerName: 'Transaksione', width: 392, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'total', headerName: 'Total', type: 'string', width: 392, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

